import { PortableTextListComponent } from '@portabletext/react'

export const Bullet: PortableTextListComponent = ({ children }) => (
  <ul className='list-styled'>{children}</ul>
)

export const Number: PortableTextListComponent = ({ children }) => {
  return <ol>{children}</ol>
}
